import { FC } from "react";
import { Dialog } from "../../core/Dialog/Dialog";

type AccountMismatchPopupProps = {
  onClose: () => void;
  isOpen: boolean;
};

const AccountMismatchPopup: FC<AccountMismatchPopupProps> = (props) => {
  const { onClose, isOpen } = props;

  return (
    <Dialog
      open={isOpen}
      title="Account Mismatch"
      description="The account you are trying to subscribe does not match the account currently logged in. Please log out and log in with the correct account to continue."
      mainAction={{
        id: "close-dialog",
        text: "Ok",
        onClick: onClose,
        "data-gamepad": "default-selected",
      }}
    />
  );
};

export default AccountMismatchPopup;
